import { render, staticRenderFns } from "./DetailTemplateAppDialog.vue?vue&type=template&id=06578b0c&scoped=true"
import script from "./DetailTemplateAppDialog.vue?vue&type=script&lang=js"
export * from "./DetailTemplateAppDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailTemplateAppDialog.vue?vue&type=style&index=0&id=06578b0c&lang=css"
import style1 from "./DetailTemplateAppDialog.vue?vue&type=style&index=1&id=06578b0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06578b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06578b0c')) {
      api.createRecord('06578b0c', component.options)
    } else {
      api.reload('06578b0c', component.options)
    }
    module.hot.accept("./DetailTemplateAppDialog.vue?vue&type=template&id=06578b0c&scoped=true", function () {
      api.rerender('06578b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/templateApp/DetailTemplateAppDialog.vue"
export default component.exports